<form [formGroup]="form" (ngSubmit)="submitForm()">
  <h2 mat-dialog-title>
    <ng-container *ngIf="data.item; else newPlateTmpl">
      {{ 'common.edit' | t }}
      <span class="plateGroupName">
        {{ data.item.plate }}
      </span>
    </ng-container>
    <ng-template #newPlateTmpl>
      {{ 'vehicleIntelligence.hotlist.groups.addPlateTo' | t }}
      <span class="plateGroupName">
        {{ data.group.name }}
      </span>
    </ng-template>
  </h2>
  <mat-dialog-content class="mat-typography">
    <sn-form [form]="form" [fields]="formFields" [model]="formModel"></sn-form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button color="warn" mat-dialog-close>{{ 'common.cancel' | t }}</button>
    <button
      mat-button
      color="success"
      [mtBasicSpinner]="isLoading"
      [disabled]="form.invalid"
      type="submit"
    >
      {{ 'common.save' | t }}
    </button>
  </mat-dialog-actions>
</form>
